var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kudos__item",class:'kudos-image-' + _vm.item.class},[_c('div',{staticClass:"kudos__item__border",class:(_vm.wallpaper.kudos != null && (_vm.item.fileName == _vm.wallpaper.kudos.fileName)) ? 'is-active' : '',on:{"click":_vm.selectKudos}},[_c('img',{attrs:{"src":_vm.imageSrc}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0967cb14","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panels/KudosItem.vue
// module id = 275
// module chunks = 0